var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.628 1.604a.374.374 0 0 0-.633.271v3.637c-.935.055-1.78.221-2.548.542-.977.408-1.788 1.047-2.496 1.942-.745.942-1.252 2.494-1.568 3.698-.414 1.58-.631 3.195-.883 4.806.711-.8 1.389-1.647 2.169-2.383 1.43-1.35 3.3-2.604 5.326-2.638v3.616c0 .329.395.498.633.27l7.199-6.88zm-.633 8.378h1.498v2.465l4.145-3.962-4.145-3.962v2.465h-.749c-1.118 0-1.994.144-2.72.448-.717.299-1.33.77-1.899 1.488-.52.659-.96 1.893-1.276 3.085 1.482-1.117 3.256-2.003 5.146-2.027",
    clipRule: "evenodd"
  })));
};
export default SvgShareIcon;